const account_center = {
    not_enabled: 'Центр аккаунта не включен.',
    field_not_editable: 'Поле не редактируется.',
    field_not_enabled: 'Поле не включено.',
};
export default Object.freeze(account_center);
